var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.0625 1.25V2.9375M11.9375 1.25V2.9375M1.25 13.0625V4.625C1.25 4.17745 1.42779 3.74823 1.74426 3.43176C2.06072 3.11529 2.48995 2.9375 2.9375 2.9375H13.0625C13.5101 2.9375 13.9393 3.11529 14.2557 3.43176C14.5722 3.74823 14.75 4.17745 14.75 4.625V13.0625M1.25 13.0625C1.25 13.5101 1.42779 13.9393 1.74426 14.2557C2.06072 14.5722 2.48995 14.75 2.9375 14.75H13.0625C13.5101 14.75 13.9393 14.5722 14.2557 14.2557C14.5722 13.9393 14.75 13.5101 14.75 13.0625M1.25 13.0625V7.4375C1.25 6.98995 1.42779 6.56073 1.74426 6.24426C2.06072 5.92779 2.48995 5.75 2.9375 5.75H13.0625C13.5101 5.75 13.9393 5.92779 14.2557 6.24426C14.5722 6.56073 14.75 6.98995 14.75 7.4375V13.0625",
    stroke: "#00848D",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.704cbb7fe831f11def49a9aee095c50b.svg";
export { ForwardRef as ReactComponent };